const getHostname = () => {
    if (typeof window === 'undefined') {
        return '';
    }
    return window.location.hostname || '';
};

const isLanHost = (hostname) => /^192\.168\.1\.(\d{1,3})$/.test(String(hostname || ''));

export const normalize_latest_version = (value) => {
    if (value === '') {
        return '';
    }
    if (value === false) {
        return false;
    }
    if (value === null || value === undefined) {
        return false;
    }

    const parsedValue = Number(value);
    if (Number.isNaN(parsedValue)) {
        return value;
    }

    if (parsedValue === 6) {
        return 3;
    }

    if (parsedValue === 5) {
        return (getHostname() === 'localhost' || isLanHost(getHostname())) ? 3 : 1;
    }

    return parsedValue;
};

export const get_latest_version_text = (value) => {
    const normalizedValue = normalize_latest_version(value);

    if (
        normalizedValue === false ||
        normalizedValue === null ||
        normalizedValue === undefined
    ) {
        return '';
    }

    return String(normalizedValue).trim();
};
